import React, { useEffect,  useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import Drawer from "../../components/Drawer/Drawer";
import CustomAccordion from "../../components/Accordion/Accordion";
import CarDetail from "../../components/CarFormSection/CarDetailSection";
import DescriptionOfNonconformanceOrObservation from "../../components/CarFormSection/NonconformanceSection";
import EvidenceofNonconformance from "../../components/CarFormSection/EvidenceofNonconformance/Index";
import Communications from "../../components/CocSummaryReportSection/Communications";
import Docupload from "../../components/Docupload/Docupload";
import "./style.css";
import deleteIcon from "../../assets/images/delete-icon.svg"
import saveIcon from "../../assets/images/saveIcon.svg";
import Toaster from "../../components/Toaster/Toster";
import Loader from "../../components/Loader/loader.components";
import ModalComponent from "../../components/Modal";
import { CarService } from "../../services";

interface CarFormData {
  CarDetail: {
    scheme: string;
    issueDate: string;
    grade:string;
    primaryStandardReference: string;
    status: string;
    section: string;
    siteIssuedTo: string;
    name: string;
    revertedDraft: string;
  };
  EvidenceofNonconformance: {
    evidence: string;
  };
  DescriptionOfNonconformanceOrObservation: {
    description: string;
  };
  Communications: {
    message: string;
  };
  DocumentUpload: File[];
}

interface CarFormProps {
  lookupdata: any;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onAddCar: (newCar: any) => void;
  onDeleteCar:(id: string) => void;
  handleAddOrCloseCARFrom: () => void;
  carData: any;
  formType: string;
  isloading: boolean;
  carId: any;
  projectId: any;
  scheme:any;
  grade:any;
  folderPath:any;
  certifiedSiteData: any[]
}

const CarForm: React.FC<CarFormProps> = ({
  drawerOpen,
  setDrawerOpen,
  onAddCar,
  onDeleteCar,
  handleAddOrCloseCARFrom,
  carData,
  formType,
  lookupdata,
  isloading,
  carId,
  projectId,
  scheme,
  grade,
  folderPath,
  certifiedSiteData
}) => {
  const [isLoading, setIsLoading] = useState(isloading);
  const [isCardReadOnly, setIsCardReadOnly] = useState(false);
  const isCARReverted = (carData?.Reverted_Draft__c === 'true') ? true : false;

  const initialFormData: CarFormData = {
    CarDetail: {
      scheme: "",
      grade:grade,
      issueDate: "",
      primaryStandardReference: "",
      status: "",
      section: "",
      siteIssuedTo: "",
      name: "",
      revertedDraft: ""
    },
    EvidenceofNonconformance: {
      evidence: "",
    },
    DescriptionOfNonconformanceOrObservation: {
      description: "",
    },
    Communications: {
      message: "",
    },
    DocumentUpload: [],
  };

  const [formData, setFormData] = useState<CarFormData>(
    initialFormData || carData
  );

  const [show, setShow] = useState<boolean>(false);
  const [addOrUpdateCARTosterInfo, setAddOrUpdateCARTosterInfo] = useState<{type: "success" | "error"  | "warning", message: string}>({type: "success", message: ""});
  const accordion  = [
    {
      key: 1,
      title: "CAR Detail",
      data: <CarDetail formData={formData} setFormData={setFormData} carData={carData} certifiedSiteData={certifiedSiteData} disabled={isCardReadOnly} />,
      isOpen: true,
    },
    {
      key: 2,
      title: "Description of Nonconformance or Observation",
      data: (
        <DescriptionOfNonconformanceOrObservation
          formData={formData}
          setFormData={setFormData}
          disabled={isCardReadOnly}
        />
      ),
      isOpen: true,
    },
    {
      key: 3,
      title: "Evidence of Nonconformance",
      data: (
        <EvidenceofNonconformance
          formData={formData}
          setFormData={setFormData}
          disabled = {isCardReadOnly}
        />
      ),
      isOpen: true,
    },
    // {
    //   key: 4,
    //   title: "Review of CAR Evidence",
    //   data: (
    //     <ReviewofCAREvidence
    //       formData={formData}
    //       setFormData={setFormData}
    //     />
    //   ),
    //   isOpen: true,
    // },
  ];

  const [selectedAccordian, setSelectedAccordian] = useState(Object.values(accordion).map(({key}) => key));


  useEffect(() => {
    // Check if the form is in 'edit' mode and carData is provided
    if (formType === "edit" && carData) {
      setFormData({
        CarDetail: {
          scheme: scheme || "", // Assuming CARName__c maps to 'scheme'
          name: carData.Name || "",
          grade: grade || carData.Grade__c, // Maps to 'grade'
          issueDate: carData.CreatedDate || "", // Maps to 'issueDate'
          primaryStandardReference: carData.Primary_Standard_Reference__c || "", // Maps to 'primaryStandardReference'
          status: carData.Status__c || "Draft", // Maps to 'status'
          section: carData.Clause__c || "", // Maps to 'section' (use the field that makes sense)
          siteIssuedTo: carData.Customer_Site__c || "", // Maps to 'siteIssuedTo'
          revertedDraft: carData.Reverted_Draft__c || ""
        },
        EvidenceofNonconformance: {
          evidence: carData.Non_Conformance_Evidence__c || "", // Maps to 'evidence'
        },
        DescriptionOfNonconformanceOrObservation: {
          description: carData.Observation_Description_of_Nonconforma__c || "", // Maps to 'description'
        },
        Communications: {
          message: carData.Communications || "", // You can adjust this based on available data
        },
        DocumentUpload: carData.DocumentUpload || [], // If document upload is available in carData
      });
    }
    let isReadOnly = carData?.Status__c === "Findings Review";
    setIsCardReadOnly(isReadOnly);
  }, [formType, carData]);
  
  const onFileChange = (files: File[]) => {
    setFormData((prevData) => ({
      ...prevData,
      DocumentUpload: files,
    }));
  };

  const handleClose = () => {
    setDrawerOpen(false);
    handleAddOrCloseCARFrom();
  };

  const toggleAccordion = (accordionKey: number) => {
    setSelectedAccordian(accordion => accordion.includes(accordionKey) ? accordion.filter(ac => ac !== accordionKey) : [...accordion, accordionKey])
  };

  const handleSubmit = async (open: boolean) => {
    setIsLoading(true);
  
    // // Collect missing fields
    // const missingFields: string[] = [];
  
    // // Check CarDetail fields
    // Object.entries(formData.CarDetail).forEach(([key, value]) => {
    //   if (value === "" || value === null) {
    //     missingFields.push(key);
    //   }
    // });
  
    // // Check additional fields
    // if (formData.EvidenceofNonconformance.evidence === "") {
    //   missingFields.push("Evidence of Nonconformance");
    // }
    // if (formData.DescriptionOfNonconformanceOrObservation.description === "") {
    //   missingFields.push("Description of Nonconformance");
    // }
  
    // // If there are missing fields, show a warning message
    // if (missingFields.length > 0) {
    //   console.log("Form validation failed. Missing fields:", missingFields.join(", "));
    //   setShow(true);
    //   setAddOrUpdateCARTosterInfo({
    //     type: "warning",
    //     message: `Please fill in all required fields: ${missingFields.join(", ")}`,
    //   });
    //   setIsLoading(false);
    //   setDrawerOpen(true);
    //   return; // Stop execution if validation fails
    // }
  
    // If all fields are filled, proceed with updating the CAR
    if (formType === "edit") {
      const updatedCar = {
        // ...carData,
        scheme: formData.CarDetail.scheme,
        issueDate: formData.CarDetail.issueDate,
        grade: formData.CarDetail.grade,
        primaryStandardReference: formData.CarDetail.primaryStandardReference,
        status: formData.CarDetail.status || "Draft",
        section: formData.CarDetail.section,
        siteIssuedTo: formData.CarDetail.siteIssuedTo,
        description: formData.DescriptionOfNonconformanceOrObservation.description,
        evidence: formData.EvidenceofNonconformance.evidence,
        observationDescriptionOfNonconformance: formData.DescriptionOfNonconformanceOrObservation.description,
        nonconformanceEvidence: formData.EvidenceofNonconformance.evidence,
        otherApplicableReferences: "string",
        reverted: isCARReverted ? true : false
      };
  
      onAddCar(updatedCar);
      CarService.updateCAR(carId, updatedCar)
        .then((responses) => {
          if (responses.isSuccess) {
            setShow(true);
            setIsLoading(false);
            setAddOrUpdateCARTosterInfo({
              type: "success",
              message: `CAR ${responses.id} was updated successfully`,
            });
            setDrawerOpen(true);
          }
        })
        .catch((error) => {
          setShow(true);
          setAddOrUpdateCARTosterInfo({
            type: "error",
            message: "We could not update the CAR Report. Please try again.",
          });
        });
    }
  };

   const submitCARForRevision = async (open: boolean) => {
    setIsLoading(true);
    if (formType === "edit") {
      const updatedCar = {
        // ...carData,
        scheme: formData.CarDetail.scheme,
        issueDate: formData.CarDetail.issueDate,
        grade: formData.CarDetail.grade,
        primaryStandardReference: formData.CarDetail.primaryStandardReference,
        status: "Findings Review",
        section: formData.CarDetail.section,
        siteIssuedTo: formData.CarDetail.siteIssuedTo,
        description: formData.DescriptionOfNonconformanceOrObservation.description,
        evidence: formData.EvidenceofNonconformance.evidence,
        observationDescriptionOfNonconformance: formData.DescriptionOfNonconformanceOrObservation.description,
        nonconformanceEvidence: formData.EvidenceofNonconformance.evidence,
        otherApplicableReferences: "string",
        reverted: false
      };
  
      onAddCar(updatedCar);
      CarService.updateCAR(carId, updatedCar)
        .then((responses) => {
          if (responses.isSuccess) {
            setShow(true);
            setIsLoading(false);
            setAddOrUpdateCARTosterInfo({
              type: "success",
              message: `CAR ${responses.id} was updated successfully`,
            });
            setDrawerOpen(true);
          }
        })
        .catch((error) => {
          setShow(true);
          setAddOrUpdateCARTosterInfo({
            type: "error",
            message: "We could not update the CAR Report. Please try again.",
          });
        });
    }
  };
  

  // Delete CAR toster functionality
  const [showCarDeleteModal, setShowCarDeleteModal] = useState(false);

  const handleDeleteCarModal = () => {
    setShowCarDeleteModal(false)
    onDeleteCar(carData.id)
  }

  return (

    <div className="text-center">
      <Drawer
        isOpen={drawerOpen}
        onClose={handleClose}
        title={formData.CarDetail.name}
        status={formData.CarDetail.status}
        revertedDraft = {formData.CarDetail.revertedDraft}
      >
        {!isLoading ? "" :
          <Loader />
        }
        {accordion.map((section) => (
          <CustomAccordion
            key={section.key}
            title={section.title}
            data={section.data}
            isOpen={selectedAccordian.includes(section.key)}
            toggleAccordion={() => toggleAccordion(section.key)}
          />
        ))}
        <Row>
          <Col md={6}>
            <Communications
              projectId={projectId}
              carId={carId}
              recipientUser={""}
              formData={formData}
              setFormData={setFormData}
              sidebyside={false}
              disabled={false}
            />
          </Col>
          <Col md={6}>
            <Card
              className="p-5 p-lg-3"
              style={{
                borderRadius: "12px",
                boxShadow: "0px 0px 4px 0px #00000026",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="document-Upload-heading">Documents Upload</h2>
              </div>
              <Docupload onFileChange={onFileChange} disabled={isCardReadOnly} folderPath={folderPath}/>
            </Card>
          </Col>
        </Row>
        <div className="d-flex justify-content-end mt-5 gap-3">
          { (!isCARReverted && !isCardReadOnly) && <> <Button
          className={`rounded-pill ${carId ? "carform-delete-btn"  : "carform-save-btn"}`}
          disabled={!carId}
          onClick={() => setShowCarDeleteModal(true)}
        >
          <img src={deleteIcon} alt="Delete Icon" className="save-icon" />
          Delete CAR</Button> </> }
          
          { !isCardReadOnly && <><Button
            className="rounded-pill save-btn"
            onClick={() => {handleSubmit(false)}}

          >
            <img src={saveIcon} alt="Save Icon" className="save-icon" />
            Save
          </Button> </>}
          
          {
            isCARReverted && <> <Button className="rounded-pill save-btn"  onClick={() => {submitCARForRevision(false)}} >
              <img src={saveIcon} alt="Save Icon" className="save-icon" />
              Re-Submit CAR
            </Button> </>
          }
         {
           /*  Commented for - YA502-515
            <Button
            variant="success"
            className="px-5 py-2 rounded-pill save-btn ms-3"
            onClick={() => {
              handleSubmit(false); 
              setFormData(initialFormData); 
              setDrawerOpen(true);
              setIsLoading(false);
            }}
          >
            <img src={saveIcon} alt="Save Icon" className="save-icon" />
            Save and Create New
          </Button>
           */
         } 

        </div>
      </Drawer>
      <Toaster
        type={addOrUpdateCARTosterInfo.type}
        show={show}
        setShow={setShow}
        message={addOrUpdateCARTosterInfo.message}
      />
      <ModalComponent 
        type="error" 
        title="Delete CAR" 
        enableFooter={true} 
        btnText="Delete CAR"
        show={showCarDeleteModal}
        setShow={setShowCarDeleteModal}
        onConfirmModal={handleDeleteCarModal}>
          <p>"Are you sure you would like to permanently delete this CAR from this Project?" </p>
          <p><i>Note: This action cannot be undone.</i></p>
        </ModalComponent>
    </div>
  );
};

export default CarForm;
